import { render, staticRenderFns } from "./BirimIyılestirmeleri.vue?vue&type=template&id=2a706b50"
import script from "./BirimIyılestirmeleri.vue?vue&type=script&lang=js"
export * from "./BirimIyılestirmeleri.vue?vue&type=script&lang=js"
import style0 from "./BirimIyılestirmeleri.vue?vue&type=style&index=0&id=2a706b50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports